import { useUISize } from 'app/utils/web-helpers';
import { ContactInformationScreen as ContactInformationScreenSmall } from './contact-information.small';
import { ContactInformationScreen as ContactInformationScreenLarge } from './contact-information.large';

export const ContactInformationScreen: typeof ContactInformationScreenSmall = (props) => {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <ContactInformationScreenSmall {...props} />;
  }
  return <ContactInformationScreenLarge {...props} />;
};
